// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"YY-z","sponsoredTooltipWrapper":"ZY-z","sponsoredTooltip":"_Y-z","newCard":"aZ-z"};